interface TooltipProps {
  text: string
  children: React.ReactNode
}

export const Tooltip = ({ text, children }: TooltipProps) => {
  return (
    <div className="group relative">
      {children}
      <div className="pointer-events-none absolute -top-7 left-1/2 -translate-x-1/2 opacity-0 transition-opacity group-hover:opacity-100">
        <div className="whitespace-nowrap rounded bg-[#2D2E32] px-2 py-1 text-xs text-white shadow-sm">
          {text}
        </div>
        <div className="absolute left-1/2 top-full h-0 w-0 -translate-x-1/2 border-l-[4px] border-r-[4px] border-t-[4px] border-l-transparent border-r-transparent border-t-[#2D2E32]"></div>
      </div>
    </div>
  )
}
